<template>
  <div class="liveList flex-row-start-start">
    <div class="side-left">
      <div :class="['side-name',cur == index ? 'active':'']" v-for="(item, index) in sideList" :key="index" @click="changeTab(index,item)">
        {{ item.name }}
      </div>
    </div>
    <div class="side-right">
      <div v-if="cur == 0">
        <watch-set></watch-set>
      </div>
      <div v-if="cur == 1">
        <live-set></live-set>
      </div>
      <div v-if="cur == 2">
        <attention-set></attention-set>
      </div>
      <div v-if="cur == 3">

      </div>
    </div>
  </div>
</template>
<script>
  import liveSet from "./liveSet/index.vue"
  import watchSet from "./watchSet/index.vue"
  import attentionSet from "./attentionSet/index.vue"

export default {
  components:{
    liveSet,
    watchSet,
    attentionSet
  },
  name:'liveList',
  data(){
    return {
      sideList: [
        {id:0, name: "观看页对接" },
        {id:1, name: "直播管理系统对接" },
        {id:2, name: "对接注意事项" },
        {id:3, name: "示例代码下载" },
      ],
      cur:0
    }
  },
  methods:{
    changeTab(index,item){
      this.cur = index

      if(item.name == '示例代码下载'){
        let url =  'https://qncdn.youinsh.cn/saas_pro/demo/live-demo-1.0.3.zip'

        window.open(url);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.liveList{
  width: 100%;
  height: 100%;
  .side-left {
    width: 200px;
    height: 100%;
    background-color: #fff;
    .side-name {
      border: 1px solid #dedede;
      text-align: center;
      padding: 20px;
      cursor: pointer;
      color: #333;
      &.active{
        color: #fff;
        background-color: #409EFF;
      }
    }
  }
  .side-right {
    margin-left: 20px;
    flex: 1;
    background-color: #fff;
    padding: 10px 20px;
    overflow: scroll;
    height: 100%;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/liveList/index.vue